import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';
import { swiperOnResize } from '../../utils/swiperOnResize.utils.js';

let valuesSwiperWr = document.querySelectorAll('.values-swiper-wr');
valuesSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slides = el.querySelectorAll('.swiper-slide');
    let slidesCount = slides.length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    const valuesDecor = el.querySelector('.values-slider__decor-mob');

    if (window.innerWidth <= 851) {
      const wrapper = swiperEl.querySelector('.swiper-wrapper');
      if (!wrapper) return;

      const slides = wrapper.querySelectorAll('.swiper-slide');

      if (slides.length < 6) return;

      const slide4 = slides[3];
      const slide5 = slides[4];
      const slide6 = slides[5];

      slide4.remove();
      slide5.remove();
      slide6.remove();

      const anchor = slides[6] || null;

      wrapper.insertBefore(slide6, anchor);
      wrapper.insertBefore(slide5, anchor);
      wrapper.insertBefore(slide4, anchor);
    }

    swiperOnResize('(max-width: 851px)', swiperEl,
        {
          modules: [Autoplay, Navigation],
          slidesPerView: 1,
          spaceBetween: 24,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
          navigation: {
            prevEl: prevEl,
            nextEl: nextEl,
          },
        },
    );

    // После полной инициализации считаем ширину
    const calculateTotalSlidesWidth = () => {
      let totalWidth = 0;
      slides.forEach(slide => {
        totalWidth += slide.offsetWidth; // реальная ширина каждого слайда
      });
      totalWidth += 24 * (slidesCount - 1) - (slides[0].offsetWidth + 24); // добавляем spaceBetween между слайдами
      // console.log('Общая ширина всех слайдов с учетом отступов:', totalWidth);
      valuesDecor.style.maxWidth = totalWidth + 'px';
      return totalWidth;
    };

    // Ждём, пока все слайды отрисуются
    window.addEventListener('load', () => {
      calculateTotalSlidesWidth();
    });

    window.addEventListener('resize', () => {
      calculateTotalSlidesWidth();
    });
  }
});